






























import {Component, Vue} from 'vue-property-decorator'
import StoryboardItem from '@/components/StoryboardItem.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ShotThumbnail from '@/components/VideoTimeline/ShotThumbnail.vue'
import draggable from 'vuedraggable'
import {projectStore} from '@/store'
import {shotStore} from '@/store'
import ShotAddFabButton from '@/components/Shots/ShotAddFabButton.vue'
import {
  IndexSignatureStrOfAny,
  SceneShot,
  Shot,
  ShotTypes,
  StillShot,
  TitleShot,
  VideoShot
} from '@/store/shots'
import AddShotDialog from '@/components/Shots/AddShotDialog.vue'

@Component({
  name: 'storyboard',
  components: {StoryboardItem, VuePerfectScrollbar, ShotThumbnail, draggable, ShotAddFabButton, AddShotDialog}
})
export default class Storyboard extends Vue {
  dragOptions = {
    animation: 150
  }
  private shotClassTypes: IndexSignatureStrOfAny = {
    still: StillShot, video: VideoShot, scene: SceneShot, title: TitleShot,
  }
  dialog: {open: boolean; shot: Shot} = {
    open: false,
    // Note: Property modified by child components (AddShotDialog and it's child forms). Do not pass Vuex references!
    shot: new StillShot
  }
  ShotTypes = ShotTypes

  get shots() {
    return projectStore.shots
  }

  get project() {
    return projectStore.project
  }

  async onDragChange(event: any) {
    // event is like {moved: {element: el, newIndex: 1, oldIndex: 0}}
    if ('moved' in event) {
      const change = event.moved
      await projectStore.changeShotOrder({shot: change.element, newIndex: change.newIndex, oldIndex: change.oldIndex})
    }
  }

  openAddShotDialog(kind: ShotTypes) {
    // Note: Property modified by child components (AddShotDialog and it's child forms). Do not pass Vuex references!
    this.dialog.shot = new this.shotClassTypes[kind]({kind})
    this.dialog.open = true
  }

  closeAddShotDialog() {
    this.dialog.open = false
  }

  saveNewShot() {
    if (!this.project)
      return

    try {
      projectStore.addShot(this.dialog.shot)
      this.dialog.open = false
      this.$toast.success('Shot saved.')
    } catch (err) {
      this.$toast.error('Shot save failed!')
      this.$log.error(err)
    }
  }
}
